/*!
 * Copyright (c) REWE Digital GmbH
 */
import { h } from "@stencil/core";
/**
 * Checkbox Component.
 * Stencil Checkbox issue therefor we hacked it https://github.com/ionic-team/stencil/issues/1899.
 * Solution is to hide Checkbox behind SPAN and make only surrounding div clickable.
 */
export class VxCheckbox {
    constructor() {
        this.handleInputChange = () => {
            if (!this.disabled) {
                this.handleChange({
                    target: {
                        name: this.name,
                        type: 'checkbox',
                        value: null,
                    },
                });
            }
        };
        this.handleInputKey = (ev) => {
            if (ev.key === 'Enter') {
                this.handleInputChange();
            }
            else if (ev.key === ' ') {
                ev.preventDefault();
                this.selected = !this.selected;
                ev.target.checked = this.selected;
                this.handleInputChange();
            }
        };
        this.label = undefined;
        this.labelAsHtml = false;
        this.name = undefined;
        this.selected = false;
        this.disabled = false;
        this.handleChange = undefined;
    }
    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render() {
        return (h("div", { key: '7418b834ee089d94c697e4f470678c2bddeb9298', class: 'vx-checkbox', onKeyDown: this.handleInputKey, onClick: this.handleInputChange }, h("input", { key: '601566b7b0f2df17e58beac7f812d280abe4b357', class: 'vx-checkbox__input', type: 'checkbox', checked: this.selected, name: this.name, disabled: this.disabled, "aria-label": `${this.label} ${this.selected ? 'abwählen' : 'auswählen'}` }), this.labelAsHtml
            ? h("span", { class: 'vx-checkbox__label', innerHTML: this.label })
            : h("span", { class: 'vx-checkbox__label' }, this.label)));
    }
    static get is() { return "vx-checkbox"; }
    static get encapsulation() { return "scoped"; }
    static get originalStyleUrls() {
        return {
            "$": ["vx-checkbox.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vx-checkbox.css"]
        };
    }
    static get properties() {
        return {
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Lable of Checkbox."
                },
                "attribute": "label",
                "reflect": false
            },
            "labelAsHtml": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Label as HTML."
                },
                "attribute": "label-as-html",
                "reflect": false,
                "defaultValue": "false"
            },
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Value of Checkbox."
                },
                "attribute": "name",
                "reflect": false
            },
            "selected": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "State of checkbox."
                },
                "attribute": "selected",
                "reflect": false,
                "defaultValue": "false"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Disables checkbox."
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "handleChange": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "(e: ChangeHandlerType) => void",
                    "resolved": "(e: ChangeHandlerType) => void",
                    "references": {
                        "ChangeHandlerType": {
                            "location": "global",
                            "id": "global::ChangeHandlerType"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Action on checkbox."
                }
            }
        };
    }
    static get elementRef() { return "host"; }
}
//# sourceMappingURL=vx-checkbox.js.map
